import { Stack, ContentBlock, Box } from 'braid-design-system';
import type React from 'react';

import * as styles from './Skeleton.css';

interface SidebarSkeletonProps {
  itemsToDisplay?: number;
}

const SkeletonLoader: React.FC = () => (
  <Box className={styles.skeletonContainer}>
    <Box className={styles.skeletonRow}>
      <Box className={styles.skeletonLogo} />
      <Box className={styles.skeletonDescription}>
        <Box className={`${styles.skeletonText} ${styles.skeletonName}`} />
        <Box className={`${styles.skeletonText} ${styles.skeletonTime}`} />
      </Box>
    </Box>
    <Box className={styles.skeletonText} style={{ width: '90%' }} />
    <Box className={styles.skeletonText} style={{ width: '80%' }} />
  </Box>
);

export const ThreadSkeleton: React.FC<SidebarSkeletonProps> = ({
  itemsToDisplay,
}) => {
  if (!itemsToDisplay) return null;

  return (
    <ContentBlock width="medium">
      <Stack space="large">
        <Box>
          <SkeletonLoader />
          {!itemsToDisplay ? (
            <SkeletonLoader />
          ) : (
            Array.from({ length: itemsToDisplay }, (_, index) => (
              <SkeletonLoader key={index} />
            ))
          )}
        </Box>
      </Stack>
    </ContentBlock>
  );
};

export default ThreadSkeleton;
